<template>
  <div id="app" class="container-fluid">
    <div class="inner-container">
      <h1 class="text-center">Score: {{correct}}/{{totalQuestions}}</h1>
      <hr />
      <div v-if="activeQuestion" class="trivia-form">
        <b-form-group :label="activeQuestion.prompt">
          <b-form-radio-group
                  v-model="selected"
                  :options="activeQuestion.choices"
                  name="radio-options"
                  :disabled="isProcessing"
                  stacked />
          <div class="m-3">
            <b-button :variant="buttonVariant" size="lg" block @click="evaluateAndNextQuestion">
              {{buttonMessage}}
            </b-button>
          </div>
        </b-form-group>
      </div>
      <div v-if="!activeQuestion" class="text-center">
        <h2>Congratulations!</h2>
        <p class="lead">You won this game of family trivia, show me this to collect your prize!</p>
      </div>
    </div>
  </div>
</template>

<script>
import Questions from './components/QuestionManager'
export default {
  name: 'App',
  components: {
  },
  data () {
    this.shuffle(Questions)
    const activeQuestion = Questions.pop()
    return {
      isCorrect: null,
      correct: 0,
      selected: null,
      activeQuestion: activeQuestion,
      questions: Questions
    }
  },
  computed: {
    totalQuestions: function () {
      let total = 0
      total += this.questions.length
      if (this.activeQuestion) {
        total += 1
      }
      total += this.correct
      return total
    },
    isProcessing: function () {
      return this.isCorrect === true || this.isCorrect === false
    },
    buttonVariant: function () {
      switch (this.isCorrect) {
        case true:
          return 'success'
        case false:
          return 'danger'
      }
      return 'primary'
    },
    buttonMessage: function () {
      switch (this.isCorrect) {
        case true:
          return 'Yay that\'s correct!'
        case false:
          return 'Nope, try again!'
      }
      return 'Submit!'
    }
  },
  methods: {
    evaluateAndNextQuestion: function () {
      this.isCorrect = this.selected === this.activeQuestion.answer
      setTimeout(() => {
        if (this.isCorrect) {
          this.correct++
        } else {
          this.questions.push(this.activeQuestion)
        }
        this.isCorrect = null
        const activeQuestion = this.questions.shift()
        if (!activeQuestion) {
          this.activeQuestion = null
        } else {
          this.shuffle(activeQuestion.choices)
          this.activeQuestion = activeQuestion
        }

      }, 1000)
    },
    /**
     *
     * @param {Array} a
     * @returns {Array}
     */
    shuffle: function (a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    }
  }
}
</script>

<style>
  body {
    font-family: 'Balsamiq Sans', cursive;
    background: #e0e0e0;
    color: #1d3557;
  }

  .inner-container {
    margin: 2em;
  }

  .trivia-form {
    font-size: 1.4em;
    font-weight: 400;
  }

  .col-form-label {
    font-weight: bold;
    font-size: 1.4em;
  }
</style>
